import { useRef, useCallback } from "react";
export function useIntersection(onIntersect) {
    const unsubscribe = useRef(() => { });

    return useCallback((el) => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(intersection => {
                if (intersection.isIntersecting) {
                    onIntersect();
                }
            });
        }, { threshold: 0.5, rootMargin: '300px' });

        if (el) {
            observer.observe(el);
            unsubscribe.current = () => observer.disconnect();
        } else {
            unsubscribe.current();
        }
    }, [onIntersect]);
}